




import Vue from "vue";
import { openAPPUrlForHome } from "@/utils/openAPPUrl";

export default Vue.extend({
  name: "Mobile",
  methods: {
    handleMobile() {
      openAPPUrlForHome(location.search);
    }
  }
});
